import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import "./dishesSection.css";

// Import dishes subsections
import AllDishesSubsection from "./AllDishes/AllDishesSubsection";
import CreateDishComponent from "./CreateDish/CreateDishComponent";
import Hint from "../../utils/Hint/Hint";

const DishesSection = ({
  dishes,
  isDishesLoading,
  handleCreateDish,
  handleUpdateDish,
  handleDeleteDish
}) => {
  let match = useRouteMatch();

  return (
    <section className="section dishesSection">
      {isDishesLoading ? (
        <div className="dishesLoadingSpinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : null}
      <h2 className="sectionHeading">ITEMS</h2>
      <Hint
        hintHeading="Items"
        hintText={`
        <div>
        <div>
          The interface, responsible for working with dishes and other items (e.g. disposable tableware) in the database.
          </div>
          <div>
          Each item card contains detailed information about the item, can be edited, copied, deleted, and created from scratch.
          </div>
          <div>
          The full version of the application supports <code>.xls</code> files upload/download as well as integration with 3d party product accounting systems.
          </div>
          </div>
        `}
        openOnMount={false}
        top="5em"
        right="3em"
      />
      <Switch>
        <Route path={`${match.path}/create_item`}>
          <CreateDishComponent
            dishes={dishes}
            isDishesLoading={isDishesLoading}
            handleCreateDish={handleCreateDish}
            handleUpdateDish={handleUpdateDish}
            handleDeleteDish={handleDeleteDish}
          />
        </Route>
        <Route path={match.path}>
          <AllDishesSubsection
            dishes={dishes}
            isDishesLoading={isDishesLoading}
            handleUpdateDish={handleUpdateDish}
            handleDeleteDish={handleDeleteDish}
            handleCreateDish={handleCreateDish}
          />
        </Route>
      </Switch>
    </section>
  );
};

export default DishesSection;
